module.exports = __webpack_public_path__ + "fonts/DigitalNumbers-Regular.373a1f60.woff";